import React, { Component } from 'react';
import { compose } from 'redux'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import withAuth from '../../components/withAuth';
import InvoicesFilters from '../../components/Invoices/InvoicesFilters'
import { getCurrentFunctionName } from '../../performanceModeManager';
import InvoicesList from '../../components/Invoices/InvoicesList';
import InvoicesCounters from '../../components/Invoices/InvoicesCounters';
import { setFilteredAndSortedInvoices } from '../../redux/invoices/invoicesActions';
import moment from "moment";
import { formatStatus, getColorFromStatusLabel } from '../../redux/invoices/invoicesStatusActions';
import InvoiceStatusIcon from '../../components/Invoices/InvoiceStatusIcon';
import { formatType } from '../../redux/invoices/invoicesTypesActions';
import { formatAmountToString, mobileAndTabletCheck } from '../../utils'
import { OUT_REFUND } from '../../redux/invoices/invoicesConstants';

class Invoices extends Component {

    constructor(props) {
        super(props);

        if (!this.props.invoicesFilters.displayAsList || mobileAndTabletCheck())//Chargement déjà effectué par le composant table
            this.props.setFilteredAndSortedInvoices({ ...this.props.invoicesFilters }, this.props.affair, this.props.intervention,
                this.props.tableState, this.props.activeUser, this.props.sites.selectedSite, this.props.sites.sites, this.props.tableState.nbTotalResults);

        this.state = {
            columns: [
                {
                    Header: "Numéro",
                    width: 120,
                    accessor: "number",
                },
                {
                    Header: "Type",
                    minWidth: 100,
                    maxWidth: 200,
                    id: 'type',
                    accessor: i => formatType(i.type),
                },
                {
                    Header: "Date facture",
                    width: 150,
                    id: 'date_invoice',
                    accessor: a => moment(a.date_invoice).format("DD/MM/YYYY"),
                },
                // {
                //     Header: "Statut",
                //     id: 'state',
                //     accessor: (i) => formatStatus(i.state),
                //     Cell: (cellInfo) => {
                //         let invoice = this.props.invoicesFilters.filteredAndSortedInvoices.filter((a) => !a.deleted)[cellInfo.index];

                //         if (!invoice)
                //             return null;

                //         return (
                //             <>
                //                 <InvoiceStatusIcon state={invoice.state} type={invoice.type} coloredBackground/>
                //                 <span className={"status-icon-color-" + getColorFromStatusLabel(invoice.state, invoice.type, true)} >
                //                     {formatStatus(invoice.state)}
                //                 </span>
                //             </>
                //         )
                //     },
                //     minWidth: 100,
                //     maxWidth: 200,
                // },
                {
                    Header: "Montant HT",
                    minWidth: 100,
                    maxWidth: 200,
                    id: "amount_untaxed",
                    accessor: i => (i.type === OUT_REFUND ? "-" : "") + formatAmountToString(i.amount_untaxed)
                },
                {
                    Header: "Montant TTC",
                    minWidth: 100,
                    maxWidth: 200,
                    id: "amount_total",
                    accessor: i => (i.type === OUT_REFUND ? "-" : "") + formatAmountToString(i.amount_total)
                },
                {
                    Header: "Date échéance",
                    width: 150,
                    id: 'date_due',
                    accessor: i => moment(i.date_due).format("DD/MM/YYYY"),
                    className: "",
                },
            ]
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.sites.selectedSite !== this.props.sites.selectedSite)
            this.props.setFilteredAndSortedInvoices({ ...this.props.invoicesFilters }, this.props.affair, this.props.intervention,
                this.props.tableState, this.props.activeUser, this.props.sites.selectedSite, this.props.sites.sites, this.props.tableState.nbTotalResults);
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding-only-small-screen">
                {!this.props.withoutFilters ? (
                    <InvoicesFilters invoicesFilters={this.props.invoicesFilters} {...this.props} />
                ) : null}
                <InvoicesCounters columns={this.state.columns} />
                <InvoicesList {...this.props} columns={this.state.columns} invoicesFilters={this.props.invoicesFilters}
                    filteredAndSortedInvoices={this.props.invoicesFilters.filteredAndSortedInvoices} />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        invoicesFilters: state.invoices,
        sites: state.sites,
        tableState: state.tableState,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilteredAndSortedInvoices: (invoicesFilters, affair, intervention, tableState, user, customerSiteId, allSites, nbTotalResults) =>
            dispatch(setFilteredAndSortedInvoices(invoicesFilters, affair, intervention, tableState, user, customerSiteId, allSites, nbTotalResults)),
    };
};

export default compose(withAuth, withRouter, connect(mapStateToProps, mapDispatchToProps))(Invoices);
